import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 50px;
`

export const InfoHeader = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 18px;
  line-height: 100%;
  text-align: center;
  display: block;
  font-weight: 700;
  letter-spacing: 0;
  margin: auto;
`

export const Helper = styled.span`
  display: block;
  font-size: 12px;
  font-style: normal;
  line-height: 18px;
  text-align: center;
  color: ${({ theme }) => theme.colors.grayscale.black};
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
`

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.brand.orange};
  text-decoration: underline;
`
